import { isRejectedWithValue, Middleware } from "@reduxjs/toolkit";
import { notification } from "antd";
import { t } from "i18next";

/**
 * Log an error and show a notification!
 */
const rtkQueryErrorLogger: Middleware = () => (next) => (action) => {
  const getErrorDescription = () => {
    if (action.payload.data) {
      return action.payload.data.hasErrors
        ? action.payload.data.errorMessage
        : JSON.stringify(action.payload.data.errors);
    }
    return t("something_went_wrong");
  };

  if (isRejectedWithValue(action)) {
    const message = action.payload.data?.title
      ? `Error ${action.payload.status} ${action.payload.data.title}`
      : `Error ${action.payload.status}`;

    const description = getErrorDescription();

    notification.error({
      message,
      description,
    });
  }

  return next(action);
};

export default rtkQueryErrorLogger;
